<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="`确认删除`"
        @confirm="confirm"
    >
        <div class="content">
            <div class="commonLine">
                <div class="left">
                    <span>移动网吧到分组：</span>
                </div>
                <div class="right">
                    <select
                        name="barMoveGroupSelector"
                        v-model="groupSelectId"
                        class="sel1"
                    >
                        <option
                            v-for="(item, index) in groupList"
                            v-show="item.groupId != delGroupId"
                            :value="item.groupId"
                            v-text="item.groupName"
                            :key="index"
                        ></option>
                    </select>
                </div>
            </div>
        </div>
    </default-modal>
</template>

<script>
// 头部tag内容
import DefaultModal from "_c/modals/defaultModal";
import { mapState } from "vuex";

export default {
    name: "barModals",
    components: {
        DefaultModal
    },
    data() {
        return {
            title: "删除分组",
            groupSelectId: "",
            // 删除的分组id
            delGroupId: ""
        };
    },
    mounted() {
        window.$modal.delBarGroupTo = {};
        window.$modal.delBarGroupTo.show = groupId => {
            this.delGroupId = groupId;
            this.init();
        };
    },
    computed: {
        ...mapState({
            groupList: state => state.user.barGroupList
        })
    },
    methods: {
        init() {
            this.$refs.box.clearWrong();
            this.groupSelectId = "";
            this.$refs.box.show();
        },
        async confirm() {
            this.$refs.box.clearWrong();
            if (!this.groupSelectId) {
                return this.$refs.box.setWrong("请选择分组");
            }
            this.$refs.box.hide();
            window.$modal.barGroupManageModal.del({
                groupId: this.delGroupId,
                toGroupId: this.groupSelectId
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/_color.scss";
@import "_style/msgbox/_comMsg.scss";

.content {
    padding-top: 20px;
    height: 100px;
}
</style>
